import React from 'react'
import styled from 'styled-components';
import { T } from './Console';

function HeaderBell({action}) {
  return (
     <BellWrap onClick={action} >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
        </svg>
        <BellBadge>0</BellBadge>
    </BellWrap>
  )
}


const BellBadge = styled.span`
  position: absolute;
  top: -4px; right: -4px;
  width: 16px; height: 16px;
  background: #ef4444;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  display: flex; align-items: center; justify-content: center;
`;

const BellWrap = styled.div`
  position: relative;
  cursor: pointer;
  svg { width: 20px; height: 20px; color: #6b7280; }
`;

export default HeaderBell
